import {useState} from 'react';
import {motion} from 'framer-motion';

export default ({button, onClick}) => {
    const [hovered, setHovered] = useState(false);

    if(button)
        return <div className="claim-button disabled"></div>

    return (
        <motion.div
            className="claim-button"
            onHoverStart={() => setHovered(true)}
            onHoverEnd={() => setHovered(false)}
            onClick={e => {
                onClick();
            }}
            animate={{
                scale: hovered ? 1 : [1, 1.015, 1],
            }}
            transition={hovered ? {
                duration: 0.15,
            } : {
                duration: 1.6,
                repeat: Infinity,
                ease: 'easeInOut',
            }}
        />
    )
}